var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 847,
    height: 485,
    viewBox: "0 0 847 485",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.5 28L830.5 472M822.5 472L426 39L814.5 472M422.5 43L807.5 472M426 50.5L799.5 472M426 57L792 472M426 64.5L783 472M426 71L774.5 472M426 77.5L765 472M426 84.5L758 472M426 90.5L753.5 476M426 97.5L748.5 476M426 105.5L742.5 476M426 112.5L735 476M433 127L727 476M433 135L718.5 476M436 142.5L709 476M436 150.5L702.5 476M440 160.5L693.5 476",
    stroke: "#A9A9A6",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.262 242.652L462.444 150.475L488.242 7.19922L471.179 9.69854L445.408 150.475L492.732 397.501L514.449 385.113L483.262 242.652ZM424.454 30.0463H409.214L431.665 139.5H445.408L431.665 65.3356L424.454 30.0463Z",
    fill: "#D9DBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 40L0 484M8 484L408 47L16 484M412 51L23 484M412 61L31 484M412 66L38.5 484M412 73L47.5 484M412 81L56 484M415.5 87L65.5 484M415.5 94L72.5 484M415.5 100.5L77 488M419 107.5L82 488M419 114.5L88 488M424.5 120.5L95.5 488M424.5 130.5L103.5 488M424.5 139L112 488M428.5 147L121.5 488M428.5 154.5L128 488M432.5 162.5L137 488",
    stroke: "#A9A9A6",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.5 17L887.5 461M879.5 461L479.5 24L871.5 461M475.5 28L864.5 461M475.5 38L856.5 461M475.5 43L849 461M475.5 50L840 461M475.5 58L831.5 461M472 64L822 461M472 71L815 461M472 77.5L810.5 465M468.5 84.5L805.5 465M468.5 91.5L799.5 465M463 97.5L792 465M463 107.5L784 465M463 116L775.5 465M459 124L766 465M459 131.5L759.5 465M455 139.5L750.5 465",
    stroke: "#A9A9A6",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.449 385.113L492.732 397.501L445.408 150.475L471.179 9.69854L488.242 7.19922L462.444 150.475L483.262 242.652L514.449 385.113Z",
    fill: "#D9DBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.454 30.0463H409.214L395.063 7.19922H402.547L410.874 9.26387L418.249 19.234L423.773 26.7048L424.454 30.0463Z",
    fill: "#CCCEB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.829 30.046H434.931L434.876 28.3345L435.829 30.046Z",
    stroke: "#D9DBC5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.179 9.69854L445.408 150.475L492.732 397.501L491.154 398.397L473.275 386.362L450.66 245.586L450.633 245.531V245.423L450.388 243.901L450.334 244.227L437.298 193.562L399.635 395.898H379.66L427.501 165.825L395.063 7.19922L409.214 30.0463L417.813 65.2813L435.829 65.5258L450.796 66.1778L460.375 27.1395L471.179 9.69854ZM418.575 77.9952L422.521 92.9639V92.964H447.068V92.9639L451.64 77.9952L451.64 77.9951H418.575V77.9952ZM425.733 114.751V114.752H445.408V114.751V100.435V100.435H425.733V100.435V114.751ZM428.563 125.971L432.291 135.615H438.85L442.605 125.971L442.605 125.971H428.563L428.563 125.971Z",
    fill: "#7C8B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.334 244.227V244.254L422.113 388.427L399.635 395.898L437.298 193.562L450.334 244.227Z",
    fill: "#D9DBC5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 472,
    width: 176,
    height: 13,
    fill: "#7C8B88"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 842,
    height: 485,
    fill: "white",
    transform: "translate(5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEko);
export default __webpack_public_path__ + "static/media/eko.bdb0bc37172e7013e436fdb8a1af62dd.svg";
export { ForwardRef as ReactComponent };